import { render, staticRenderFns } from "./work-order-info.vue?vue&type=template&id=b74c15d6&"
import script from "./work-order-info.vue?vue&type=script&lang=js&"
export * from "./work-order-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports